import { Injectable } from "@angular/core";
import { JwtHelperService } from '@auth0/angular-jwt';
import { AccessPolicies, Claim, IdentityUser } from './identity.models';
import { AuthService } from "./auth.service";

@Injectable()
export class IdentityService
{
	constructor(private jwtHelper: JwtHelperService)
	{ }

	// get logged identity user
	getUser(): IdentityUser
	{
		let user: IdentityUser

		// decoding token payload
		const tokenPayload = this.jwtHelper.decodeToken(AuthService.getAccessToken());

		// loading user info
		if (tokenPayload)
		{
			user = new IdentityUser();
			user.id = tokenPayload[Claim.NameIdentifier];
			user.username = tokenPayload[Claim.Name];
			user.firstName = tokenPayload[Claim.GivenName];
			user.lastName = tokenPayload[Claim.Surname];
			user.email = tokenPayload[Claim.EmailAddress];
			user.sysAdmin = tokenPayload[Claim.SysAdmin] === 'false' ? false : true;
			user.language = tokenPayload[Claim.Language];
			user.adUser = tokenPayload[Claim.AdUser] === 'false' ? false : true;
			user.cerSupplyId = tokenPayload[Claim.CerSupplyId];
			user.cerMemberId = tokenPayload[Claim.CerMemberId];
			user.policies = JSON.parse(tokenPayload[Claim.Policies]);
		}

		return user;
	}

	isUserTokenExpired(): boolean
	{
		const token = AuthService.getAccessToken();
		try
		{
			return !token || this.jwtHelper.isTokenExpired(token);
		} catch {
			return true;
		}
	}

	// verify current user has policy
	hasPolicy(alias: AccessPolicies): boolean
	{
		// get current user
		const user: IdentityUser = this.getUser();

		if (user)
		{
			if (!user.sysAdmin)
				return user.policies.indexOf(AccessPolicies[alias].toString()) >= 0;
			else
				return true;
		}
		else
			return false;
	}
}